import { BoxControlPoint } from 'editor/utils/controlPoints';

export interface MoveBoxCPInteractionStorage {
  originX: number;
  originY: number;
  currentX: number;
  currentY: number;
  deltaX: number;
  deltaY: number;
  controlPoint: BoxControlPoint;
}

class MoveBoxCPInteraction {
  originX: number;

  originY: number;

  currentX: number;

  currentY: number;

  deltaX: number;

  deltaY: number;

  controlPoint: BoxControlPoint;

  constructor(storage: MoveBoxCPInteractionStorage) {
    this.originX = storage.originX;
    this.originY = storage.originY;
    this.currentX = storage.currentX;
    this.currentY = storage.currentY;
    this.deltaX = storage.deltaX;
    this.deltaY = storage.deltaY;
    this.controlPoint = storage.controlPoint;
  }
}

export default MoveBoxCPInteraction;
